import "./bootstrap";
import "./autoload";
import Vue from "vue";
import VueSwal from "vue-swal";
import store from "./store";
import icon from "./icons";
import trans from "./trans";
import config from "./config";
import Api from "./api";
import Datepicker from "vuejs-datepicker";
import VueMask from "v-mask";

import birthDatepicker from "vue-birth-datepicker";

//import { Datetime } from 'vue-datetime';
//import { Settings } from 'luxon'
//import 'vue-datetime/dist/vue-datetime.css'

//Settings.defaultLocale = 'en'

Vue.use(VueMask);
Vue.use(VueSwal);
//Vue.use(birthDatepicker);
//Vue.use(Datetime);

import AppAuth from "./Components/Auth/Index";
import AppAlert from "./Components/Alert";
import AppModal from "./Components/Modal";
import AppQuote from "./Components/Quote";
import AppQuoteInfo from "./Components/QuoteInfo";
import AppQuotes from "./Components/QuoteSteps/Quotes";
import AppQuotePayment from "./Components/QuoteSteps/Payment";
import QuoteItem from "./Components/QuoteSteps/QuoteItem";
import Loader from "./Components/QuoteSteps/Loader";
import AccountInfoForm from "./Components/AccountInfoForm";
import "vue-birth-datepicker/dist/vueBirthDatepicker.css";
import { Tooltip } from "floating-vue";
import "floating-vue/dist/style.css";

import { translate } from "./filters/translate";
import { truncate } from "./filters/truncate";

window.yna.bus = new Vue();
Vue.prototype.$icon = icon;
Vue.prototype.$trans = trans;
Vue.prototype.$config = config;
Vue.prototype.$api = new Api();

Vue.component("app-auth", AppAuth);
Vue.component("app-alert", AppAlert);
Vue.component("app-modal", AppModal);
Vue.component("app-quote", AppQuote);
Vue.component("app-quote-info", AppQuoteInfo);
Vue.component("app-quotes", AppQuotes);
Vue.component("app-quote-payment", AppQuotePayment);
Vue.component("app-quote-item", QuoteItem);
Vue.component("app-loader", Loader);
Vue.component("app-datepicker", Datepicker);
Vue.component("account-info-form", AccountInfoForm);
//Vue.component('datetime', Datetime);
//Vue.component('vue-datetime', window.VueDatetime.Datetime);
Vue.component("birth-datepicker", birthDatepicker);
Vue.component("v-tooltip", Tooltip);

Vue.filter("__", translate);
Vue.filter("truncate", truncate);
Vue.use(Tooltip, {
    themes: {
        "info-tooltip": {
            $extend: "tooltip"
        }
    }
});

export const QUOTE_STEPS = {
    car: {
        SELECT_COVERAGE: "CarQuoteSelectCoverage",
        DRIVER_INFO: "CarQuoteDriverInfo"
    },
    home: {
        SELECT_COVERAGE: "HomeQuoteSelectCoverage"
    }
};

const app = new Vue({
    el: "#app",

    store,

    data: {},

    mounted() {}
});

window.yna.app = app;
